export const PLANS = [
  {
    id: "basic",
    name: "Basic Shield",
    price: 20,
    coverage: 2000,
    payoutPerHour: 100,
    color: "#3B82F6",
    triggers: ["Heavy Rain", "Heatwave"],
    fraud: "Basic",
    priority: false,
    features: ["Rain & heat protection", "Basic fraud detection", "Email support", "Offline claims"],
  },
  {
    id: "guard",
    name: "Storm Guard",
    price: 45,
    coverage: 3500,
    payoutPerHour: 150,
    color: "#8B5CF6",
    triggers: ["Heavy Rain", "Heatwave", "Extreme AQI", "City Curfew"],
    fraud: "Advanced",
    priority: false,
    recommended: true,
    features: ["All weather events", "AQI + curfew coverage", "Advanced fraud detection", "Priority support", "Offline claims"],
  },
  {
    id: "shield",
    name: "Full Shield",
    price: 80,
    coverage: 5000,
    payoutPerHour: 250,
    color: "#22c55e",
    triggers: ["Heavy Rain", "Heatwave", "Extreme AQI", "City Curfew", "Platform Outage"],
    fraud: "Premium AI",
    priority: true,
    features: ["Complete coverage", "Platform outage included", "Premium AI fraud detection", "24/7 support", "Priority payouts", "Offline claims"],
  },
];

export const DISRUPTIONS = [
  { id: "rain", icon: "🌧️", label: "Heavy Rainfall", value: "67mm recorded", amount: 300, color: "#3B82F6", threshold: ">50mm" },
  { id: "heat", icon: "🌡️", label: "Heatwave Alert", value: "44°C recorded", amount: 250, color: "#F97316", threshold: ">42°C" },
  { id: "aqi", icon: "💨", label: "Extreme AQI", value: "AQI 342", amount: 200, color: "#8B5CF6", threshold: ">300" },
  { id: "curfew", icon: "🚫", label: "City Curfew", value: "Zone 4 Active", amount: 300, color: "#EF4444", threshold: "Active" },
  { id: "flood", icon: "🌊", label: "Urban Flooding", value: "Roads submerged", amount: 280, color: "#0ea5e9", threshold: "Water level > 30cm" },
  { id: "outage", icon: "⚡", label: "Platform Outage", value: "App down", amount: 220, color: "#c084fc", threshold: "Service interruption" },
  { id: "cyclone", icon: "🌀", label: "Cyclone Watch", value: "Coastal alert", amount: 320, color: "#f97316", threshold: "Category 2+" },
  { id: "strike", icon: "🚧", label: "Road Block / Strike", value: "Delivery routes blocked", amount: 260, color: "#facc15", threshold: "Verified local incident" },
  { id: "hail", icon: "🧊", label: "Hailstorm Alert", value: "Ice impact risk", amount: 240, color: "#60a5fa", threshold: "Hail warning active" },
  { id: "landslide", icon: "⛰️", label: "Landslide Block", value: "Hill route closed", amount: 300, color: "#f59e0b", threshold: "District closure alert" },
  { id: "fog", icon: "🌫️", label: "Dense Fog Alert", value: "Visibility critical", amount: 210, color: "#94a3b8", threshold: "Visibility < 50m" },
  { id: "waterlog", icon: "🚰", label: "Waterlogging", value: "Main route submerged", amount: 230, color: "#22d3ee", threshold: "Road depth > 15cm" },
];

export const PERSONAS = {
  raju: {
    id: "raju", name: "Raju Kumar", phone: "9000000001", email: "raju.k@gmail.com",
    platform: "Swiggy", partnerId: "SWG-2024-HYD-4521", city: "Hyderabad", zone: "Madhapur",
    hours: "8-10 hrs/day", since: "Mar 2021", age: "3 years", avatar: "RK",
    plan: "guard", balance: 4200, totalClaims: 12, approvedClaims: 11,
    tag: "Genuine Worker", tagColor: "#22c55e", scenario: "safe",
    description: "Consistent 3-year delivery partner. Trusted device, active routes, clean history.",
    expectedScore: "12 â€” Safe",
    history: [
      { id:"CLM-001", date:"Mar 15, 2026", type:"Heavy Rainfall", duration:"6 hrs", amount:300, status:"Paid",    score:12, time:"2:00â€“8:00 PM" },
      { id:"CLM-002", date:"Feb 28, 2026", type:"Extreme AQI",    duration:"4 hrs", amount:200, status:"Paid",    score:8,  time:"10:00 AMâ€“2:00 PM" },
      { id:"CLM-003", date:"Feb 10, 2026", type:"Heatwave Alert", duration:"5 hrs", amount:250, status:"Paid",    score:15, time:"12:00â€“5:00 PM" },
      { id:"CLM-004", date:"Jan 22, 2026", type:"Heavy Rainfall", duration:"3 hrs", amount:300, status:"Paid",    score:10, time:"4:00â€“7:00 PM" },
      { id:"CLM-005", date:"Jan 08, 2026", type:"City Curfew",    duration:"2 hrs", amount:0,   status:"Not met", score:5,  time:"6:00â€“8:00 PM" },
    ],
    alerts: [
      { type:"Heatwave Alert", zone:"Madhapur", prob:85, time:"2:00â€“8:00 PM Today", color:"#EF4444" },
      { type:"Pollution Alert",    zone:"Kondapur", prob:65, time:"Next 4 hours",        color:"#F97316" },
    ],
    signals: [
      { signal:"Weather API match",    raw:0,  label:"Heatwave confirmed at Madhapur — 45C recorded",   status:"pass" },
      { signal:"Movement pattern",     raw:0,  label:"Active route â€” 4.2km movement detected",       status:"pass" },
      { signal:"Device integrity",     raw:0,  label:"Trusted device, same phone 3 years",           status:"pass" },
      { signal:"Historical behaviour", raw:12, label:"Consistent 3yr pattern, 11 prior paid claims", status:"pass" },
      { signal:"Geo-cluster check",    raw:0,  label:"Only 1 claim in this zone â€” no cluster",       status:"pass" },
    ],
    decision:"safe", outcome:"Auto payout approved",
    outcomeDetail:"All 5 signals clear. Raju is genuinely stranded. Payout released instantly.",
  },
  meena: {
    id:"meena", name:"Meena Devi", phone:"9000000002", email:"meena.d@gmail.com",
    platform:"Amazon", partnerId:"AMZ-2026-CHN-0892", city:"Chennai", zone:"Anna Nagar",
    hours:"6-8 hrs/day", since:"Mar 7, 2026", age:"12 days", avatar:"MD",
    plan:"basic", balance:0, totalClaims:0, approvedClaims:0,
    tag:"Genuine â€” New Account", tagColor:"#F97316", scenario:"medium",
    description:"New worker, genuine disruption but flagged due to new account + new device.",
    expectedScore:"55 â€” Delayed",
    history:[],
    alerts:[
      { type:"Heavy Rain Warning", zone:"Anna Nagar", prob:78, time:"3:00â€“9:00 PM Today", color:"#EF4444" },
    ],
    signals:[
      { signal:"Weather API match",    raw:0,  label:"Rain confirmed at Anna Nagar â€” 58mm recorded", status:"pass" },
      { signal:"Movement pattern",     raw:30, label:"Low movement â€” sheltering from rain detected",  status:"warn" },
      { signal:"Device integrity",     raw:0,  label:"New device â€” first time registered",            status:"warn" },
      { signal:"Historical behaviour", raw:15, label:"Account only 12 days old â€” no prior claims",   status:"warn" },
      { signal:"Geo-cluster check",    raw:0,  label:"Only 1 claim in zone â€” no cluster detected",   status:"pass" },
    ],
    decision:"medium", outcome:"Claim delayed â€” soft verification",
    outcomeDetail:"Meena is genuine but new. Low movement + new account triggers soft hold. 2hr re-check window opened. Payout will release after verification.",
  },
  priya: {
    id:"priya", name:"Priya Sharma", phone:"9000000003", email:"priya.s@gmail.com",
    platform:"Zomato", partnerId:"ZMT-2025-BLR-3341", city:"Bengaluru", zone:"Koramangala",
    hours:"8-10 hrs/day", since:"Jul 2023", age:"8 months", avatar:"PS",
    plan:"guard", balance:950, totalClaims:6, approvedClaims:4,
    tag:"Insider Fraud â€” Worker Gaming System", tagColor:"#EF4444", scenario:"fraud",
    description:"Real registered worker, 8 months history â€” but sitting at home, faked location using spoofing app.",
    expectedScore:"85 â€” Blocked",
    history:[
      { id:"CLM-006", date:"Mar 10, 2026", type:"Heavy Rainfall", duration:"5 hrs", amount:0,   status:"Blocked", score:78, time:"2:00â€“7:00 PM" },
      { id:"CLM-007", date:"Feb 20, 2026", type:"Heavy Rainfall", duration:"4 hrs", amount:0,   status:"Flagged", score:71, time:"3:00â€“7:00 PM" },
      { id:"CLM-008", date:"Jan 15, 2026", type:"Heatwave Alert", duration:"5 hrs", amount:250, status:"Paid",    score:22, time:"12:00â€“5:00 PM" },
      { id:"CLM-009", date:"Dec 10, 2025", type:"Heavy Rainfall", duration:"3 hrs", amount:300, status:"Paid",    score:18, time:"4:00â€“7:00 PM" },
    ],
    alerts:[],
    signals:[
      { signal:"Weather API match",    raw:40, label:"NO rain at device GPS â€” Koramangala clear sky",  status:"fail" },
      { signal:"Movement pattern",     raw:30, label:"Zero movement 3hrs â€” static home location",      status:"fail" },
      { signal:"Device integrity",     raw:0,  label:"Trusted device â€” no emulator detected",          status:"pass" },
      { signal:"Historical behaviour", raw:15, label:"2 prior suspicious claims flagged in pattern",   status:"fail" },
      { signal:"Geo-cluster check",    raw:0,  label:"Single claim â€” no coordinated group detected",   status:"pass" },
    ],
    decision:"fraud", outcome:"Claim blocked â€” insider fraud detected",
    outcomeDetail:"Priya is a real worker but faked her location. Weather API confirms no rain at her actual device location. Pattern of 2 prior false claims confirmed. Account escalated.",
  },
  vikram: {
    id:"vikram", name:"Vikram (Acc #7749)", phone:"9000000004", email:"v7749@tempmail.com",
    platform:"Zepto", partnerId:"ZPT-2026-MUM-7749", city:"Mumbai", zone:"Dharavi",
    hours:"Unknown", since:"Mar 29, 2026", age:"3 days", avatar:"V7",
    plan:"basic", balance:0, totalClaims:0, approvedClaims:0,
    tag:"GPS Spoofer â€” Fraud Ring", tagColor:"#EF4444", scenario:"fraud",
    description:"Fake account. Part of 47-person Telegram syndicate using GPS spoofing emulator.",
    expectedScore:"135 â€” Blocked + Ring Flagged",
    history:[],
    alerts:[],
    signals:[
      { signal:"Weather API match",    raw:40, label:"NO rain at spoofed GPS â€” clear sky Dharavi",      status:"fail" },
      { signal:"Movement pattern",     raw:30, label:"Static emulator pattern â€” no real movement",      status:"fail" },
      { signal:"Device integrity",     raw:20, label:"Emulator signature â€” GPS spoofing app detected",  status:"fail" },
      { signal:"Historical behaviour", raw:15, label:"Account 3 days old â€” created before event",      status:"fail" },
      { signal:"Geo-cluster check",    raw:30, label:"47 claims â€” identical coordinates fraud ring",    status:"fail" },
    ],
    decision:"fraud", outcome:"Claim blocked â€” GPS fraud ring detected",
    outcomeDetail:"GPS spoofing confirmed. Emulator detected. Part of 47-account Telegram syndicate all claiming from identical coordinates. Account permanently flagged. Ring reported to authorities.",
  },
};

export const WEATHER_FORECAST = [
  { day:"Today",    icon:"ðŸŒ§ï¸", temp:"28Â°C", rain:"67mm", aqi:145, risk:"HIGH" },
  { day:"Tomorrow", icon:"ðŸŒ¦ï¸", temp:"29Â°C", rain:"12mm", aqi:98,  risk:"LOW"  },
  { day:"Wed",      icon:"â˜€ï¸", temp:"30Â°C", rain:"0mm",  aqi:80,  risk:"LOW"  },
  { day:"Thu",      icon:"â›…", temp:"31Â°C", rain:"5mm",  aqi:95,  risk:"LOW"  },
  { day:"Fri",      icon:"â˜€ï¸", temp:"32Â°C", rain:"0mm",  aqi:75,  risk:"LOW"  },
];
